module.exports = __webpack_public_path__ + "static/media/cut-paths-ex.be456025.png";